import { Heart } from "lucide-react";
import { useLang } from "@/i18n";

export default function Marquee() {
  const { t } = useLang();
  const items = [...t.marquee, ...t.marquee];

  return (
    <div className="marquee-mask relative overflow-hidden border-y border-teal-900/10 bg-[#FAF7F2] py-5" data-testid="marquee-strip">
      <div className="animate-marquee flex w-max items-center gap-10 whitespace-nowrap pr-10">
        {items.map((item, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className={`font-display text-xl italic sm:text-2xl ${i % 2 === 0 ? "text-teal-800" : "text-pink-600"}`}>
              {item}
            </span>
            <Heart className="h-4 w-4 fill-pink-300 text-pink-300" />
          </span>
        ))}
      </div>
    </div>
  );
}
